import {APIService} from './APIService';

export class CourseService extends APIService {

    static async getPublishedCourses(accessToken, page = 1, pageSize = 8) {
        return await this.makeRequest(
            `api/courses/published?page=${page}&pageSize=${pageSize}`,
            null,
            {
                'Content-Type': 'application/json',
                'x-access-token': accessToken
            },
            APIService.METHOD_GET
        );
    }

    static async getOnDemandCourses(accessToken, page = 1, pageSize = 8) {
        return await this.makeRequest(
            `api/courses/on-demand?page=${page}&pageSize=${pageSize}`,
            null,
            {
                'Content-Type': 'application/json',
                'x-access-token': accessToken
            },
            APIService.METHOD_GET
        );
    }

    static async getCourse(uid, accessToken) {
        return await this.makeRequest(
            `api/courses/${uid}`,
            null,
            {
                'Content-Type': 'application/json',
                'x-access-token': accessToken
            },
            APIService.METHOD_GET
        );
    }

}
